import React, { useContext, useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Snackbar,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ICustomMenu from "models/CustomMenu";
import { StyledMenu } from "./StyledMenu";
import useEditGoalMutation from "hooks/mutations/useEditGoalMutation";
import { useGetGoals } from "hooks/queries/useGetGoals";
import useDeleteGoalMutation from "hooks/mutations/useDeleteGoalMutation";
import { useSnackbar } from "hooks/useSnackbar";
import { findPermission } from "utilities/findPermission";
import { AuthContext } from "navigation/AuthProvider";
import { specialNames } from "constants/specialNames";

export const GoalActionButton = ({
  anchorEl,
  open,
  handleClose,
  goalData,
  setGoalData,
}: ICustomMenu) => {
  const { showSnackbar, getSnackbarProps } = useSnackbar();
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const { refetch } = useGetGoals();
  const { mutate: editGoal } = useEditGoalMutation({
    callback: () => refetch(),
    id: goalData.id,
    showSnackbar,
  });
  const { mutate: deleteGoal } = useDeleteGoalMutation({
    callback: () => refetch(),
    id: goalData.id,
    showSnackbar,
  });

  const { user } = useContext(AuthContext);
  console.log("User", user);

  const theme = useTheme();

  const openEditDialog = () => {
    setOpenDialog(true);
    setGoalData(goalData);
    handleClose();
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const openDeleteConfirmationDialog = () => {
    setDeleteConfirmationOpen(true);
    handleClose();
  };

  const closeDeleteConfirmationDialog = () => {
    setDeleteConfirmationOpen(false);
  };

  const handleDelete = () => {
    deleteGoal(goalData.id);
    refetch();
    closeDeleteConfirmationDialog();
  };

  const handleOnchange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setGoalData({ ...goalData, [name]: value });
  };

  const handleEditGoal = () => {
    const payload = {
      title: goalData?.title,
      weight: goalData?.weight,
    };
    editGoal({ payload });
    closeDialog();
  };

  const canEditGoal = [specialNames.MANAGER];
  const canEditGoalPermission = findPermission(canEditGoal, user.user.roles[0].name);

  return (
    <>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{ "aria-labelledby": "demo-customized-menu" }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={openEditDialog} disableRipple>
          <EditIcon />
          Edit
        </MenuItem>
        <MenuItem onClick={openDeleteConfirmationDialog} disableRipple>
          <DeleteIcon />
          Delete
        </MenuItem>
      </StyledMenu>

      {/* Edit Dialog here */}

      <Dialog open={openDialog} onClose={closeDialog}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "center",
            color: theme.palette.primary.main,
            fontWeight: 800,
          }}
        >
          Edit Goal
        </DialogTitle>
        <DialogContent>
          <TextField
            name="title"
            label="Edit goal title"
            margin="normal"
            value={goalData?.title || ""}
            onChange={handleOnchange}
            fullWidth
          />
          <TextField
            name="weight"
            label="Edit goal weight"
            margin="normal"
            value={goalData?.weight || ""}
            onChange={handleOnchange}
            fullWidth
            // disabled={!canEditGoalPermission}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="error" onClick={closeDialog}>
            Cancel
          </Button>
          <Button variant="contained" onClick={() => handleEditGoal()} color="primary">
            SUBMIT
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Dialog here */}

      <Dialog open={deleteConfirmationOpen} onClose={closeDeleteConfirmationDialog}>
        <DialogTitle style={{ backgroundColor: "#f44336", color: "white" }}>
          <Typography variant="h6" color="inherit" fontWeight={800}>
            Confirmation
          </Typography>
        </DialogTitle>
        <DialogContent style={{ padding: "16px 32px" }}>
          <Typography variant="body1">Are you sure you want to Delete this Goal ?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteConfirmationDialog} color="error">
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDelete}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        {...getSnackbarProps()}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={4000}
      >
        <Alert {...getSnackbarProps()}>{getSnackbarProps().message}</Alert>
      </Snackbar>
    </>
  );
};
